import styled from 'styled-components';
import { AllieButtons } from '../../Buttons/Buttons';
import { AllieButton } from '../../Buttons/Button';

export const ButtonsContainer = styled(AllieButtons)`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-lg);
  padding: 0;
  width: calc(100vw - 64px);
`;

export const StyledSelectButton = styled(AllieButton)`
  color: white;
  background: var(--allie-color-primary-60);
  display: flex;
  justify-content: center;
  padding: 10px;
  border-radius: var(--allie-spacing-md);
  box-sizing: border-box;
  height: 45px !important;
`;

export const StyledCancelButton = styled(AllieButton)`
  border: 1px solid var(--allie-color-neutral-30);
  display: flex;
  justify-content: center;
  padding: 10px;
  border-radius: var(--allie-spacing-md);
  box-sizing: border-box;
  height: 45px !important;
`;
